import LocalisedApp from './LocalisedApp'

export default LocalisedApp
